import { Enum } from './Enum';

export default new Enum({
    NAO_DEFINIDO: { value: 0, text: ' ' },
    REQUISICAO_WMS: { value: 1, text: 'Requisições' },
    MOVIMENTO_ENTRADA_SAIDA: { value: 2, text: 'Operações' }
});
